import { Component, OnInit, inject } from '@angular/core';
import {HeaderTextService} from '../../../services/header-text.service';
import {ShowSidebarService} from '../../../services/show-sidebar.service';
import {AuthWebservice} from '../../../services/webservices/auth.webservice';
import {environment} from '../../../../environments/environment';
import {Destroyed} from '../directives/destroyed.directive';
import {MatToolbarModule} from '@angular/material/toolbar';
import {formatDate, NgClass} from '@angular/common';
import {LogoutWebservice} from "../../../services/webservices/logout.webservice";

@Component({
    standalone: true,
    selector: 'app-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    imports: [MatToolbarModule, NgClass]
})
export class ToolbarComponent extends Destroyed implements OnInit {
  private readonly headerTextService = inject(HeaderTextService);
  private readonly showSidebarService = inject(ShowSidebarService);
  readonly logoutService = inject(LogoutWebservice);
  authService = inject(AuthWebservice);

  public title = '';
  public url = '';
  public dateBuild = '';
  public version = '';
  public isRed: boolean = false;

  constructor() {
    super();
    this.dateBuild =
      environment.timestamp === '#{timestamp}' ? formatDate(Date.now(), 'dd/MM/yyyy HH:mm:ss', 'fr') : environment.timestamp;
  }

  ngOnInit() {
    this.headerTextService.title.pipe(this.untilDestroyed()).subscribe((title) => {
      this.title = title;
    });

    this.headerTextService.isRed.pipe(this.untilDestroyed()).subscribe((isRed) => {
      this.isRed = isRed;
    });
  }

  isLoggedIn() {
    return this.authService.isAuthBDD;
  }

  showSideBar() {
    this.showSidebarService.showSidebar = !this.showSidebarService.showSidebar;
  }
}
